import { Component } from 'react'
import * as Sentry from '@sentry/react'

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary] React render crash:', error, info?.componentStack)
    // Send crash to Sentry so we get notified during the unattended period.
    try {
      Sentry.captureException(error, { contexts: { react: { componentStack: info?.componentStack } } })
    } catch {}
  }

  render() {
    if (!this.state.hasError) return this.props.children

    return (
      <div style={styles.overlay}>
        <div style={styles.card}>
          <div style={styles.logo}>V</div>
          <h1 style={styles.heading}>We're updating Verse</h1>
          <p style={styles.sub}>Please check back in a few minutes.</p>
          <button
            style={styles.btn}
            onClick={() => window.location.reload()}
            onMouseOver={e => e.target.style.opacity = '0.9'}
            onMouseOut={e => e.target.style.opacity = '1'}
          >
            Refresh
          </button>
          <a
            href="/"
            style={styles.link}
            onClick={e => { e.preventDefault(); this.setState({ hasError: false }) }}
          >
            Try again
          </a>
        </div>
      </div>
    )
  }
}

const styles = {
  overlay: {
    minHeight: '100vh',
    background: '#FAF5FF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '1rem',
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },
  card: {
    textAlign: 'center',
    maxWidth: 400,
    padding: '2.5rem 2rem',
  },
  logo: {
    width: 64,
    height: 64,
    borderRadius: 16,
    background: 'linear-gradient(135deg, #7C3AED, #EC4899)',
    color: '#fff',
    fontSize: '2rem',
    fontWeight: 800,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 1.5rem',
  },
  heading: {
    fontSize: '1.4rem',
    fontWeight: 700,
    color: '#1E1B4B',
    margin: '0 0 0.5rem',
  },
  sub: {
    color: '#6B7280',
    fontSize: '0.95rem',
    margin: '0 0 1.5rem',
    lineHeight: 1.5,
  },
  btn: {
    padding: '0.75rem 2rem',
    borderRadius: 10,
    border: 'none',
    background: 'linear-gradient(135deg, #7C3AED, #EC4899)',
    color: '#fff',
    fontWeight: 700,
    fontSize: '1rem',
    cursor: 'pointer',
    display: 'inline-block',
  },
  link: {
    display: 'block',
    marginTop: '1rem',
    color: '#7C3AED',
    fontSize: '0.85rem',
    textDecoration: 'none',
    cursor: 'pointer',
  },
}
